import axios from 'axios';
import { Data } from '~/services/data-service';

export async function getData(params: any): Promise<Data[]> {
  try {
    const request = await axios.get<Data[]>('/api/data', { params });
    return request.data;
  } catch (err) {
    throw new Error('Kunde inte hämta data!');
  }
}

export async function getFilteredData(params: any, controller: AbortController): Promise<Data[]> {
  try {
    const request = await axios.post<Data[]>('/api/data/filtered', params, { signal: controller.signal });
    return request.data;
  } catch (err) {
    throw new Error('Kunde inte hämta data!');
  }
}

export async function getDataExport(params: any) {
  try {
    const request = await axios.post<Blob>('/api/data/export', params, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([request.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', request.headers['content-disposition'].split('filename=')[1].replaceAll(/"/g, ''));
    link.click();
  } catch (err) {
    throw new Error('Kunde inte exportera filen');
  }
}
